export default __webpack_public_path__ + "static/media/window.72135533.png";